import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION,
  ACT_INSTANCES_GET_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS,
} from '../../constants/actions';
import {
  addComponentSuccessAction,
  deleteComponentSuccessAction,
  fetchComponentsSuccessAction,
  getComponentSuccessAction,
} from '../../actions/instances/components';
import Api from '../../services/Api';

function* fetchComponents() {
  const { filters } = yield select(state => state.buildingComponentInstance);
  let query = '';
  if (filters.dynasties.length > 0) {
    query += filters.dynasties.map(dynasty => `&dynasties_ids[]=${dynasty}`);
  }
  if (filters.cities.length > 0) {
    query += filters.cities.map(city => `&cities_ids[]=${city}`);
  }
  if (filters.tags.length > 0) {
    query += filters.tags.map(tag => `&tags_ids[]=${tag}`);
  }
  const { status, data } = yield Api.get(`instances/building-components?per_page=50${query}`, false);
  if (status === 200) {
    yield put(fetchComponentsSuccessAction(data.data));
  }
}

function* getComponent(action) {
  const { status, data } = yield Api.get(`instances/building-components/${action.payload}`, false);
  if (status === 200) {
    yield put(getComponentSuccessAction(data));
  }
}

function* addComponent(action) {
  const { status, data } = yield Api.post('instances/building-components', action.payload, false);
  if (status === 200) {
    yield put(addComponentSuccessAction(data));
  }
}

function* deleteComponent(action) {
  const { status } = yield Api.delete(`instances/building-components/${action.payload}`, false);
  if (status === 204) {
    yield put(deleteComponentSuccessAction());
  }
}

export default function* componentsSagas() {
  yield takeEvery([
    ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION,
    ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS,
  ], fetchComponents);
  yield takeEvery(ACT_INSTANCES_GET_COMPONENT_INIT_ACTION, getComponent);
  yield takeEvery(ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION, addComponent);
  yield takeEvery(ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION, deleteComponent);
}
